import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './NissanIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const NissanIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function NissanIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 54 45" component={Icon} {...props} />
  );
});
